import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero hero-gradient">
        <div className="hero-content">
          <h1>We build reliable, scalable software for modern businesses</h1>
          <p>From MVP to enterprise scale, we design, ship, and support products that grow with you.</p>
          <div className="hero-actions">
            <Link to="/services" className="cta-btn">All Services</Link>
          </div>
        </div>
        <div className="hero-visual" aria-hidden="true">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="grid-bg"></div>
        </div>
      </section>

      {/* Highlights */}
      <section className="features">
        <h2>Why Choose Vision Forte?</h2>
        <div className="feature-list">
          <div className="feature-item">
            <h3>Custom Software, Built Around You</h3>
            <p>
              We design and develop solutions aligned to your goals, workflows, and growth plans—
              not one‑size‑fits‑all templates.
            </p>
            <ul>
              <li>Discovery workshops and clear roadmaps</li>
              <li>Modern, maintainable architectures</li>
              <li>MVPs that evolve to enterprise scale</li>
            </ul>
          </div>
          <div className="feature-item">
            <h3>Performance and Scalability by Design</h3>
            <p>
              Responsive UIs, optimized APIs, and cloud‑ready deployments that keep your product fast
              as usage grows.
            </p>
            <ul>
              <li>CI/CD, monitoring, and alerting baked in</li>
              <li>Efficient data access and caching</li>
              <li>Cost‑aware cloud architectures</li>
            </ul>
          </div>
          <div className="feature-item">
            <h3>Security and Reliability You Can Trust</h3>
            <p>
              Protecting your users and data is fundamental. We follow secure engineering practices
              across the entire lifecycle.
            </p>
            <ul>
              <li>Auth, access control, and audit trails</li>
              <li>Threat‑aware coding and reviews</li>
              <li>Backups, SLOs, and disaster readiness</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="stats">
        <div className="stat">
          <span className="stat-number">20+</span>
          <span className="stat-label">Projects delivered</span>
        </div>
        <div className="stat">
          <span className="stat-number">5x</span>
          <span className="stat-label">Average performance gain</span>
        </div>
        <div className="stat">
          <span className="stat-number">100%</span>
          <span className="stat-label">On-time milestones</span>
        </div>
      </section>

      {/* Services Preview */}
      <section id="home-services" className="section services-preview">
        <h2>What we do</h2>
        <div className="cards">
          <div className="card hoverable">
            <h3>Product Engineering</h3>
            <p>Design, build, and iterate web apps with React, Node, and modern clouds.</p>
            <Link to="/services" className="text-link">Learn more →</Link>
          </div>
          <div className="card hoverable">
            <h3>Cloud & DevOps</h3>
            <p>CI/CD pipelines, containerization, observability, and cost optimization.</p>
            <Link to="/services" className="text-link">Learn more →</Link>
          </div>
          <div className="card hoverable">
            <h3>Data & Integrations</h3>
            <p>APIs, third‑party integrations, and analytics dashboards that inform action.</p>
            <Link to="/services" className="text-link">Learn more →</Link>
          </div>
        </div>
      </section>

      {/* Tech Strip */}
      <section className="tech-strip">
        <div className="tech">React</div>
        <div className="tech">Node</div>
        <div className="tech">TypeScript</div>
        <div className="tech">AWS</div>
        <div className="tech">Docker</div>
      </section>

      {/* Testimonials */}
      <section className="section testimonials">
        <h2>What clients say</h2>
        <div className="cards">
          <div className="card quote">
            <p>“They shipped our MVP in weeks and scaled it to thousands of users.”</p>
            <span className="author">Founder, SaaS startup</span>
          </div>
          <div className="card quote">
            <p>“Clear communication, strong engineering, and dependable delivery.”</p>
            <span className="author">CTO, Fintech</span>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta">
        <h2>Ready to start your project?</h2>
        <p>Let’s discuss how we can turn your idea into reality.</p>
        <Link to="/contact" className="cta-btn">Contact Us</Link>
      </section>
    </div>
  );
}

export default Home;
